import { render } from "./BrokerCredentialsModal.vue?vue&type=template&id=40ed8f18&scoped=true"
import script from "./BrokerCredentialsModal.vue?vue&type=script&lang=js"
export * from "./BrokerCredentialsModal.vue?vue&type=script&lang=js"

import "./BrokerCredentialsModal.vue?vue&type=style&index=0&id=40ed8f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ed8f18"]])

export default __exports__